import { RedoCarrierName } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { getAvailableIntegrations } from "./get-available-integrations";
import { getGen2IntegrationStatuses } from "./integrations/get-gen2-integration-statuses";
import { getAllIntegrationStatuses } from "./returns-rpc/get-all-integration-statuses";

/**
 * Every status source the unified integrations page needs, in one round trip;
 * the server fans out to the same computations the individual RPCs use.
 */
export const getCatalogStatuses = {
  name: "getCatalogStatuses" as const,
  input: z.object({
    /** Unknown kinds in both lists are ignored so mixed client/server versions coexist. */
    gen2Kinds: z.array(z.string()),
    gen3Kinds: z.array(z.string()),
  }),
  output: z.object({
    hub: getAllIntegrationStatuses.output,
    gen2: getGen2IntegrationStatuses.output,
    gen3: getAvailableIntegrations.output,
    /** Whether the team has a live Gmail, Outlook or custom email integration in CRDB. */
    emailConnected: z.boolean().default(false),
    /** Kind keys (e.g. "gen2:KlaviyoIntegration") with an integration whose latest connection test failed. */
    unverifiedKindKeys: z.array(z.string()).default([]),
    /** Carriers whose every account failed its connection test, vs. those with an account in good standing. */
    carrierVerification: z
      .object({
        failedNames: z.array(createEnum(RedoCarrierName)),
        okNames: z.array(createEnum(RedoCarrierName)),
      })
      .default({ failedNames: [], okNames: [] }),
  }),
};
